import React, { memo } from "react";
import { PageTemplate } from "../../components/templates";
import { Container, Grid, Card, Stack } from "investira.react.components";

const PortfoliosAdd = memo(() => {
  return (
    <Container sx={{ height: "100%" }} maxWidth="md">
      <PageTemplate title="Nova Carteira" subtitle="Simulação">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card>
              <Stack spacing={2} sx={{ pt: 3, pb: 1, px: 2 }}>
                ADD
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </PageTemplate>
    </Container>
  );
});

PortfoliosAdd.displayName = "PortfoliosAdd";

export default PortfoliosAdd;
